import CreateOrLogin from './CreateOrLoginConnector';

export default CreateOrLogin;
